export default __webpack_public_path__ + "static/media/gallery_06.93c2a8fb.jpg";